<div class="db-ai-builder-create-page-preview-demo">
  <div class="title">
    <i class="db-icon db-icon-ds-arrow-small"  *ngIf="!hideBackButton"
       (click)="onBack.emit({step: 'templates', templateScreenshot: null, selectedCategory: selectedCategory})"></i>
    <h2>Page preview</h2>
  </div>

  <div class="db-ai-builder-create-page-preview-demo__content">
    <img [src]="templateScreenshot" >
  </div>
</div>

